import { render, staticRenderFns } from "./BookletsWrapper.vue?vue&type=template&id=a536697e&"
import script from "./BookletsWrapper.vue?vue&type=script&lang=ts&"
export * from "./BookletsWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports